import React from 'react';
import {
  CategorySelector as CategorySelectorNew,
  type CategorySelectorProps as CategorySelectorNewProps,
} from './CategorySelector';
import { convertOldCategorySelectorProps } from './converter.old';
import type { OldCategorySelectorProps } from './converter.old';

export type CategorySelectorProps = OldCategorySelectorProps;

// CategorySelectorDropdown이 cloneElement로 주입하는 내부 prop이며 old public API에는 노출하지 않는다.
type InternallyInjectedCategorySelectorProps = CategorySelectorProps &
  Partial<Pick<CategorySelectorNewProps, 'onChange'>>;

export const CategorySelector = (props: CategorySelectorProps) => {
  const injectedOnChange = (props as InternallyInjectedCategorySelectorProps).onChange;
  const convertedProps = convertOldCategorySelectorProps(props);
  const onChange = injectedOnChange ?? convertedProps.onChange;

  return <CategorySelectorNew {...convertedProps} onChange={onChange} />;
};
